export const TEST_ID = 'navigationDropdown';
